import * as tslib_1 from "tslib";
import { EventEmitter } from '@angular/core';
var EditToggleService = /** @class */ (function () {
    function EditToggleService() {
        this._isOn = false;
        this.toggleEmitter = new EventEmitter();
    }
    EditToggleService.prototype.setState = function (isOn) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                this._isOn = isOn;
                this.toggleEmitter.emit(this._isOn);
                return [2 /*return*/];
            });
        });
    };
    EditToggleService.prototype.getState = function () {
        return this._isOn;
    };
    return EditToggleService;
}());
export { EditToggleService };
